import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ 'otpField', 'emailField' ]

  connect() {
    const otpField = this.otpFieldTarget;
    const emailField = this.emailFieldTarget;

    if (emailField.value.includes('@hosman.co') || emailField.value.includes('@sesame-chasse.')) {
      otpField.classList.remove('vesta-display-none');
    }
  }

  check(e) {
    const otpField = this.otpFieldTarget;

    if (e.target.value.includes('@hosman.co') || e.target.value.includes('@sesame-chasse.')) {
      otpField.classList.remove('vesta-display-none');
    }
  }
}
